import { createSelector } from "reselect";

export const brandTrackedDomainsSelector = createSelector(
    state => state.brandTrackedDomain,
    state => state
);
